export default __webpack_public_path__ + "static/Plots0091-28e36aedad89aa2c1aa3ef6c55ad001f.jpg";